@if (control && config) {
  @for (checkbox of config.options; track checkbox; let i = $index) {
    <label
      class="form-control--checkbox__wrapper"
      [ngClass]="{
        'form-control--checkbox__wrapper--inline': config.inline === true,
        'form-control--checkbox__wrapper--top-aligned':
          config.isTopAligned === true,
        'form-control--checkbox__wrapper--disabled': checkbox?.isDisabled,
      }"
      [attr.for]="getCheckboxId(config, i)"
    >
      <input
        #box
        class="form-control form-control--checkbox"
        [attr.disabled]="checkbox?.isDisabled || null"
        [attr.readonly]="checkbox?.readonly || null"
        [attr.type]="config.type"
        [attr.name]="checkbox?.name"
        [checked]="control.controls[i]?.value === checkbox.value ? true : null"
        [attr.aria-checked]="control.controls[i]?.value === !!checkbox.value"
        [value]="checkbox?.value"
        (click)="toggle(checkbox, i)"
        [id]="getCheckboxId(config, i)"
        [attr.aria-describedby]="(config?.id || config?.prop) + '-label'"
        [attr.aria-errormessage]="
          'error_' + (config?.id || config?.prop) + '-input'
        "
        [attr.aria-invalid]="
          (control.dirty || control.touched) && !control.valid
        "
        ngDefaultControl
        role="checkbox"
        [formControl]="
          extraText[checkbox.label]
            ? extraText[checkbox.label]
            : control.controls[i]
        "
      />
      @if (checkbox?.label) {
        <p
          class="t-data"
          [ngClass]="{
            'form-control--checkbox__option-title':
              checkbox?.multiLines?.length || config.isBold,
          }"
          [innerHTML]="checkbox?.label"
        ></p>
      }
    </label>
    @if (checkbox?.multiLines?.length) {
      @for (lineOfText of checkbox.multiLines; track lineOfText) {
        <p
          class="t-data form-control--checkbox__multi-lines"
          [innerHTML]="lineOfText.label"
        ></p>
      }
    }
    @if (
      checkbox.type === 'other' &&
      extraText[checkbox.label] &&
      extraText[checkbox.label].value
    ) {
      <div class="form-control--checkbox__other">
        <control-text [control]="control.controls[i]" [config]="otherConfig">
        </control-text>
      </div>
    }
  }
}
